export enum PHSAnalysis {
  FAILED = 'FAILED', // 분석 오류
  IN_PROGRESS = 'IN_PROGRESS', // 분석 중
  COMPLETED = 'COMPLETED', // 분석 완료
}

export type PHSAnalysisType = keyof typeof PHSAnalysis;

export const phsAnalysisTextMap: Record<PHSAnalysisType, string> = {
  FAILED: '분석오류',
  IN_PROGRESS: '분석중',
  COMPLETED: '분석완료',
};

export const phsAnalysisStatusMap: Record<PHSAnalysisType, string> = {
  FAILED: 'failed',
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'completed',
};
